import { EmployeeSettingsTab } from './EmployeeSettingsTab.main';

export { EmployeeSettingsTab };
